import colors from '@sportninja/common/constants/appColors'
import type { AttendancePlayer, AvailabilityRequest } from '../types'

export const getPlayerDisplayName = (player: AttendancePlayer): string =>
  `${player.name_first ?? ''} ${player.name_last ?? ''}`.trim()

// Duplicate jersey highlight, gated on the unique-number game setting (matching
// mobile). Compares the string form: the API returns player_number as a number
// or a string.
export const isJerseyConflict = (
  player: AttendancePlayer,
  requireUniqueJerseyNumbers: boolean,
  duplicateJerseyNumbers: number[]
): boolean =>
  requireUniqueJerseyNumbers &&
  player.player_number != null &&
  duplicateJerseyNumbers
    .map((n) => String(n))
    .includes(String(player.player_number))

// Spare-candidate status text colour: available → green, pending → app yellow,
// unavailable → app red.
export const getSpareStatusColor = (
  status?: AvailabilityRequest['status']
): string => {
  if (status === 'available') {
    return colors.SUCCESS_300
  }
  if (status === 'pending') {
    return colors.WARNING_400
  }
  if (status === 'unavailable') {
    return colors.ERROR_300
  }
  return colors.NEUTRAL_50
}
